import {DataFetcher} from '@aboutyou/data-fetcher';
import {GetHeaderV2Response} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/brand_hub/v1/service.types';
import {useRouteEntities} from '@aboutyou/router';
import React from 'react';
import {
  BrandPreviewEntity,
  isBrandPreviewEntities,
} from '../utils/isBrandPreviewEntities';
import {
  BrandShopHeaderView,
  BrandShopHeaderViewProps,
} from './BrandPageHeaderView';
import {BrandPageHeaderLoading} from './BrandPageHeaderLoading';
import {useGetBrandPageHeader} from './utils/useGetBrandPageHeader';

export const BrandPageHeader: React.FC<BrandShopHeaderViewProps> = props => {
  const entities = useRouteEntities<BrandPreviewEntity>() as BrandPreviewEntity;

  return (
    <DataFetcher
      request={useGetBrandPageHeader()}
      // This Error component is not just missing but actually intended.
      // In this case the brand page will work without the banner (showing an empty background).
      Error={() => null}
      Loading={() => <BrandPageHeaderLoading landscape={props.landscape} />}
      View={BrandShopHeaderView}
      viewProps={props}
      computeDefaultState={() =>
        isBrandPreviewEntities(entities)
          ? ({brand: entities.brandPreview} as GetHeaderV2Response)
          : undefined
      }
    />
  );
};
